import React, { useState, useEffect, useCallback } from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import makeStyles from '@mui/styles/makeStyles';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';

import { handleResponse } from '../services/HandleResponse';
import { FormControlLabel, FormHelperText, LinearProgress,RadioGroup, Radio, Typography } from '@mui/material';
import {Form} from "./Form"
import { useAuth } from './AuthProvider';
import { ActivateCaptcha } from './ActivateCaptcha';

//import { authenticationService } from '../services/AuthenticationService';


const useStyles = makeStyles((theme)=>({
    root: {
        maxWidth: 500
    },
    margin: {
        //margin: theme.spacing(2)
    }
}));

export const Reset = ({ returnTo, ...props }) => {
    const formContext = useForm({ shouldUnregister: true });
    const { formState: { errors }, register, unregister, setValue, watch } = formContext;

    const [generalLoginError, setGeneralLoginError] = useState('');
    //const { enqueueSnackbar } = useSnackbar();
    //const [isLoggedIn, setLoggedIn] = useState(false);
    //const { setUser } = useContext(UserContext);
    //const { setAuthToken } = useContext(AuthContext);
    const classes = useStyles();
    const [resetInfo, setResetInfo] = useState({});
   // const [resetType, setResetType] = useState(null);
    const [loading, setLoading] = useState(false);
    const [refresh, setRefresh] = useState(0);
    const [auth] = useAuth();
  
    const currentValues = watch("resetType");

    useEffect(()=>{
        register("resetType");
        return ()=> unregister("resetType")
    },[register, unregister]);

    useEffect(()=>{
        register("mfaOption");
        return ()=> unregister("mfaOption")
    },[register, unregister]);
   
    const onSubmitLogin = useCallback((data, token, event) => {
        
        var sendData = {...resetInfo, recaptchaToken: token};
        if(!sendData.userName)
                sendData.userName = data.userName;
        if(data.q)
                sendData.answers = data.q;
        if(data.captcha)
            sendData.captcha = data.captcha;
        if(data.mfaOption)
            sendData.mfaOption = data.mfaOption;

        if(resetInfo.status==='ShowPin' && !sendData.mfaOption)
        {
            setLoading(false);
            setGeneralLoginError("A selection must be made.");
            return;
        }
        
        if(data.resetType && !sendData.password)
        {
            if(data.resetType==='reset')
            {
                if(data.password1 !== data.password2)
                {
                    setLoading(false);
                    setGeneralLoginError("The passwords must match");
                    return;
                }
                sendData.password = data.password1;
            }
            else
                sendData.password = ''; // Unlock only
        }
        
   
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(sendData)
        };

        return fetch(`/anywhere/api/users/reset`, requestOptions)
            .then(handleResponse)
            .then(info => {
                setResetInfo(info);
                setGeneralLoginError(null);
                setLoading(false);
                return info;
            },
            error => {
                console.log(JSON.stringify(error));
                setLoading(false);
                setGeneralLoginError(error?.message||error||"Login Error");
                setRefresh((i)=>i+1);
            }
            );

    }, [resetInfo, setResetInfo, setGeneralLoginError, setLoading]);

    const handleTypeChange = useCallback((event) => {
        setValue("resetType", event.target.value)
      }, [setValue]);
 
      const handleMFAChange = useCallback((event) => {
        setValue("mfaOption", event.target.value)
      }, [setValue]);
 
      var resetType = currentValues;

    return (
        <FormProvider {...formContext}>
        <Form title="Reset Password" setLoading={setLoading} onSubmit={(data, token, event) => onSubmitLogin(data, token, event)}>      
         <Grid item xs={12}>
            {!resetInfo.userName &&
                    <Grid container spacing={2} fullWidth flexDirection="column">
                        <Grid item>
                        <TextField
                        id="userName"
                        variant="standard"
                        {...register("userName", { required: "Please enter a user name" })}
                        className={classes.margin}
                        fullWidth
                        helperText={errors?.userName ? errors.userName.message : null}
                        label="User Name or Email"
                        error={errors?.userName}
                    />
                        </Grid>
                        <Grid item>
                        <ActivateCaptcha key={refresh}></ActivateCaptcha>
                    <TextField
                                    id="captcha"
                                    variant="standard"
                                    className={classes.margin} fullWidth
                                    {...register("captcha", { required: "This value is required." })}
                                    helperText={errors?.captcha ? errors.captcha.message : null}
                                    label={auth.config?.captchaLabel}
                                    error={errors?.captcha}
                                />
                            </Grid>
                    </Grid>

            }
            {resetInfo.status==='ShowPin' && resetInfo.mfaOptions && !resetInfo.mfaOption && !resetInfo.userAuthenticatedToken &&
                <>
                <Typography marginBottom={true}>A one time password or pin is required. Please select which method you wish to use?</Typography>
            <RadioGroup value={resetType}
                        onChange={handleMFAChange}>
                      
                      
                               
                 {resetInfo.mfaOptions.map((v, index) => {
                        var parts = v.split("\t");
                        var name = "o." + index;
                        return(
                        <FormControlLabel key={name} label={parts[1]} value={parts[0]} control={<Radio size="small" />}>
                        </FormControlLabel>
                        );
                    })}
                </RadioGroup>
                    </>

                }
                {resetInfo.status!=='Reset' && resetInfo.questions && resetInfo.mfaOption && !resetInfo.userAuthenticatedToken &&
                    resetInfo.questions.map((v, index) => {
                        var parts = v.split(":");
                        if (parts[0] === "*KEY") return null;
                        var name = "q." + index;
                        return <TextField
                            key={name}
                            id={name}
                            variant="standard"
                            {...register(name, { required: "Please enter an answer" })}
                            className={classes.margin}
                            fullWidth
                            helperText={errors[name] ? errors[name].message : null}
                            label={parts[1]}
                            error={errors[name]}
                        />
                    })
                }
                {resetInfo.status!=='Reset' && resetInfo.userAuthenticatedToken && resetInfo.mfaOption &&
                    <div>
                     <RadioGroup value={resetType}
                        onChange={handleTypeChange}>
                      
                        <FormControlLabel label="Reset Password" value="reset" control={<Radio size="small" />}>
                        </FormControlLabel>
                
                        {resetType === 'reset' && <div style={{marginBottom: 16}}>
                             <Typography variant="body2" component="div" gutterBottom={true}><pre style={{whiteSpace:"pre-wrap"}}>{resetInfo.resetText}</pre></Typography>
                            <TextField
                                variant="standard"
                                id="password1"
                                type="password"
                                {...register("password1", { required: "Please enter a password" })}
                                className={classes.margin}
                                fullWidth
                                helperText={errors?.password1 ? errors.password1.message : null}
                                label="Password"
                                error={errors?.password1}
                            />
                            <TextField
                                id="password2"
                                variant="standard"
                                type="password"
                                {...register("password2", { required: "Please enter a password" })}
                                className={classes.margin}
                                fullWidth
                                helperText={errors?.password2 ? errors.password2.message : null}
                                label="Confirm Password"
                                error={errors?.password2}
                            />
                        </div>}
                        {(resetInfo.status?.indexOf("Unlock")) >= 0 && 
                            <FormControlLabel label="Unlock Account" value="unlock" control={<Radio size="small" />}>
                            </FormControlLabel>
                        }
                    </RadioGroup>
                    </div>
                   
                }
                {resetInfo.status === 'Reset' && <div>
                    <Typography>{resetInfo.resetText}</Typography>
                    </div>}
            </Grid>
            {loading && <Grid item xs={12}>
                <LinearProgress></LinearProgress>
            </Grid>}
            <Grid item xs={12}>
                {generalLoginError && <FormHelperText error={true}> {generalLoginError}</FormHelperText> }
            </Grid>
                    <Grid item container xs={12} justifyContent="flex-end">
                    {resetInfo.status !== 'Reset' &&
                     <Button variant="contained" color="primary" type="submit" >
                            Next
                            </Button>}
                    {resetInfo.status === 'Reset' &&
                        <Button variant="contained" color="primary" href="/"  >
                            Continue
                            </Button>}
                    
                    </Grid>

                    {
                <div>
                {/*JSON.stringify(resetInfo)*/}
                </div>
                }
      
        </Form>
    </FormProvider>
    );
};